import { render, staticRenderFns } from "./PageEducatorInstitutionClassroomStudentAdd.vue?vue&type=template&id=2e1c901b&scoped=true&"
import script from "./PageEducatorInstitutionClassroomStudentAdd.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionClassroomStudentAdd.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionClassroomStudentAdd.vue?vue&type=style&index=0&id=2e1c901b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1c901b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VBtn,VCard,VCardTitle,VContainer,VDivider,VForm,VStepper,VStepperHeader,VStepperStep})
